import React, { useState } from "react";
import Header from "../../Components/layouts/Header";
import Input from "../../Components/themes/Input";

const Credit = () => {
  let row: any = '5'
  let col: any = '20'
  const [openTab, setOpenTab] = useState('New')

  return (
    <>
      <Header title="Farmer" subtitle="Credit" />
      <section className="font-roboto">
        <Input />
        <div className=" w-[78%] flex justify-center">
          <div className="flex gap-x-[10%] mt-2 w-[30%]">
            <button className={`text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] flex justify-center w-[6vw] py-1 px-3 rounded text-sm font-thin ${openTab === 'Status' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('Status') }}>Status
            </button>
            <button className={`text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] flex justify-center w-[6vw] py-1 px-4 rounded text-sm font-thin ${openTab === 'New' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('New') }}>New
            </button>
            <button className={`text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] flex justify-center w-[6vw] py-1 px-4 rounded text-sm font-thin ${openTab === 'Pay' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('Pay') }}>Pay
            </button>
          </div>
        </div>
        <form className={openTab === 'New' ? "block" : "hidden"}>
          <div className="grid grid-cols-[25%_28%] text-center items-center my-4">
            <label className="text-[#13490A] font-extrabold text-sm mx-5">Eligible Amount</label>
            <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
          </div>
          <div className="grid grid-cols-[25%_28%_15%] text-center items-center my-4">
            <label className="text-[#13490A] font-extrabold text-sm mx-5">Reason</label>
            <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            <img src="Images/Dropdown.png" className="ml-4" />
          </div>
          <div className="grid grid-cols-[25%_28%] text-center items-center my-4">
            <label className="text-[#13490A] font-extrabold text-sm mx-5">Bill Number</label>
            <input type="text" className="bg-[#F3FFF1]  h-8  shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
          </div>
          <div className="grid grid-cols-[25%_28%] text-center items-center my-4">
            <label className="text-[#13490A] font-extrabold text-sm mx-5">Value</label>
            <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
          </div>
          <div className="grid grid-cols-[53%_47%] my-4">
            <div className="grid grid-cols-[47%_53%] text-center items-center">
              <label className="text-[#13490A] font-extrabold text-sm mx-5">Credit Period</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
            <div className="grid grid-cols-[45%_50%] items-center">
              <label className="text-[#13490A] flex-[1] text-cente font-extrabold text-sm mx-5">Due Date</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 w-35 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
          </div>
          <div className="grid grid-cols-[53%_47%] my-4">
            <div className="grid grid-cols-[47%_53%] text-center items-center">
              <label className="text-[#13490A] font-extrabold text-sm mx-5">Interest Rate</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
            <div className="grid grid-cols-[45%_50%] items-center">
              <label className="text-[#13490A] flex-[1] text-cente font-extrabold text-sm mx-5">Total</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 w-35 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
          </div>
          <div className="grid grid-cols-[53%_47%] my-4">
            <div className="grid grid-cols-[47%_53%] text-center items-center">
              <label className="text-[#13490A] font-extrabold text-sm mx-5">Total Payable Amount</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
            <div className="grid grid-cols-[45%_50%] items-center">
              <label className="text-[#13490A] flex-[1] text-cente font-extrabold text-sm mx-5">Interest Amount</label>
              <input type="text" className="bg-[#F3FFF1]  h-8 w-35 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md" />
            </div>
          </div>
          <div className="w-[78%] flex justify-center">
            <button type="submit" className="bg-[#05AB2A] text-[#F3FFF1] flex justify-center shadow-[0px_4px_3px_rgba(0,0,0,0.25)] w-16 py-1 px-4 rounded text-sm font-thin">Sanction</button>
          </div>
        </form>
        <form className={openTab === 'Pay' ? "block" : "hidden"}>
          <div className=''>
            <div className='grid grid-cols-[25%_28%] text-center items-center my-4'>
              <label className='text-[#13490A]  font-roboto font-extrabold text-sm mx-5'>Credit Number</label>
              <input type='text' className='bg-[#F3FFF1]  h-8  shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md' />
            </div>
            <div className='grid grid-cols-[25%_28%] text-center items-center my-4'>
              <label className='text-[#13490A]  font-roboto font-extrabold text-sm mx-5'>Detail</label>
              <textarea cols={col} rows={row} className='bg-[#F3FFF1]  shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md' />
            </div>
            <div className='grid grid-cols-[25%_28%] text-center items-center my-4'>
              <label className='text-[#13490A]  font-roboto font-extrabold text-sm mx-5'>Amount Payable</label>
              <input type='text' className='bg-[#F3FFF1]  h-8  shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md' />
            </div>
            <div className='grid grid-cols-[25%_28%_15%] text-center items-center my-4'>
              <label className='text-[#13490A]  font-roboto font-extrabold text-sm mx-5'>Payment Method</label>
              <input type='text' className='bg-[#F3FFF1] h-8 shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md' />
              <img src='Images/Dropdown.png' className='ml-4 text-center rounded-full' />
            </div>
            <div className="w-[78%] flex justify-center">
              <button className='bg-[#05AB2A] text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] w-16 py-1 px-4 rounded text-sm font-thin'>Pay</button>
            </div>
          </div>
        </form>
      </section>
    </>
  );
};

export default Credit;
